import { useFeatureContext } from '../contexts/FeatureContext';
import { FeatureName } from './Feature.types';

export const useFeatureToggle = (flagName: FeatureName) => {
    const featureContext = useFeatureContext();
    return featureContext[flagName] as boolean;
};
